import ReactPaginate from "react-paginate";
import React from "react";
import {Paginator} from "primereact/paginator";

function Total(props){
    return (
        <div className="card page-bottom">

            <div className="row">
                <div className="col-12 col-sm-6">
                    <nav className="navigation d-flex">


                        {props.data &&
                        <ReactPaginate

                            pageCount={props.data._meta.pageCount}
                            forcePage={(props.data._meta.currentPage - 1)}
                            onPageChange={props.handlePageClick}
                            className={'pagination pagination-primary  pagination-md justify-content-center'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            activeClassName={'active'}
                            nextLabel={<i className={'pi pi-arrow-right'}></i>}
                            previousLabel={<i className={'pi pi-arrow-left'}></i> }
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                        }
                    </nav>

                </div>
                <div className="col-12 col-sm-6 text-end">
                    <div className="pagination-content">
                        <div className="f-w-600">
                        {props.data && (() => {
                            const meta = props.data._meta || {};
                            const total = meta.totalCount ?? props.data.total ?? 0;
                            const limit = meta.perPage ?? props.data.limit ?? (props.data.items ? props.data.items.length : 0);
                            const offset = props.data.offset ?? ((meta.currentPage ? (meta.currentPage - 1) : 0) * (limit || 0));
                            const start = total === 0 ? 0 : (offset + 1);
                            const end = Math.min(offset + (props.data.items ? props.data.items.length : limit || 0), total);
                            return (
                                <>Показаны {start}-{end} из {total}</>
                            );
                        })()}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Total